import Link from 'next/link'
import { AddressContainer, Map } from './Location.styles'
import { Spacing, Heading } from '@big-red-group/storefront-common-ui'
import { useElementClick } from '@/hooks/HTMLElementClickHook'
import Icon from '@/components/Icons'
import { getPublicConfig } from '@/helpers/ClientSideRenderHelper'

type LocationProps = {
  latitude: number
  longitude: number
  address: string
  dataTestId?: string
}

const Location: React.FC<LocationProps> = ({ latitude, longitude, address, dataTestId }) => {
  const { GMAPS_API_KEY } = getPublicConfig()
  const gmapsLink = `https://maps.google.com/maps?z=17&t=m&q=loc:${latitude}+${longitude}`
  // Convert snazzymaps JSON to static URI for mapStyling: https://jsfiddle.net/gaby/s6Dyp/
  const mapStyling =
    '&style=feature:administrative|element:labels.text.fill|color:0x6195a0&style=feature:administrative.province|element:geometry.stroke|visibility:off&style=feature:landscape|element:geometry|lightness:0|saturation:0|color:0xf5f5f2|gamma:1&style=feature:landscape.man_made|element:all|lightness:-3|gamma:1.00&style=feature:landscape.natural.terrain|element:all|visibility:off&style=feature:poi|element:all|visibility:off&style=feature:poi.attraction|element:all|visibility:on&style=feature:poi.business|element:all|visibility:off&style=feature:poi.park|element:all|visibility:simplified&style=feature:poi.park|element:geometry.fill|color:0xbae5ce|visibility:on&style=feature:road|element:all|saturation:-100|lightness:45|visibility:simplified&style=feature:road.highway|element:all|visibility:simplified&style=feature:road.highway|element:geometry.fill|color:0xfac9a9|visibility:simplified&style=feature:road.highway|element:labels.text|color:0x4e4e4e&style=feature:road.arterial|element:labels.text.fill|color:0x787878&style=feature:road.arterial|element:labels.icon|visibility:off&style=feature:transit|element:all|visibility:simplified&style=feature:transit.station.airport|element:labels.icon|hue:0x0a00ff|saturation:-77|gamma:0.57|lightness:0&style=feature:transit.station.rail|element:labels.text.fill|color:0x43321e&style=feature:transit.station.rail|element:labels.icon|hue:0xff6c00|lightness:4|gamma:0.75|saturation:-68&style=feature:water|element:all|color:0xeaf6f8|visibility:on&style=feature:water|element:geometry.fill|color:0xc7eced&style=feature:water|element:labels.text.fill|lightness:-49|saturation:-53|gamma:0.79'
  const mapImage = `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&markers=color:red|${latitude},${longitude}&zoom=13&size=640x370&key=${GMAPS_API_KEY}${mapStyling}`
  const pageTitle = 'Location'

  const linkClick = useElementClick('Link')

  return (
    <>
      <Heading size="L" spacing={false} dataTestId={dataTestId}>
        {pageTitle}
      </Heading>
      <Spacing />
      <AddressContainer>
        <Icon name="locationCircle" />
        <Link
          data-testid="location-link"
          href={gmapsLink}
          target="_blank"
          onClick={(event) => linkClick({ location: `${pageTitle} | ${pageTitle}`, event })}
        >
          {address}
        </Link>
      </AddressContainer>
      <Map style={{ backgroundImage: `url(${mapImage})` }} />
      <Spacing size="XXXL" />
    </>
  )
}

export default Location
